import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { Editor } from "primereact/editor";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { useEffect, useRef, useState } from "react";
import getTipoIntervaloNotificacao from "../../service/getTipoIntervaloNotificacao";
import getCanaisNotificacao from "../../service/getCanaisNotificacao";
import { Toast } from "primereact/toast";

export default function NotificacaoFaturaCadastrar({notificacaoFatura, onClose, onSave, msgs}:{notificacaoFatura:any, onClose: () => void, onSave: (notificacaoFatura:any) => void, msgs:any}) {
  const { t } = useTranslation();
  const [tiposIntervalo, setTiposIntervalo] = useState<any>([]);
  const [canais, setCanais] = useState<any>([]);
  const toast = useRef<Toast>(null);
  const defaultValues = {
    assunto: '',
    mensagem: '',
    intervaloDia: null as number | null,
    tipoIntervalo: null as string | null,
    canalNotificacao: 'EMAIL' as string,
    repete: false
  };
  defaultValues.assunto = notificacaoFatura.assunto ? notificacaoFatura.assunto.toString() : ''
  defaultValues.mensagem = notificacaoFatura.mensagem ? notificacaoFatura.mensagem.toString() : ''
  defaultValues.intervaloDia = notificacaoFatura.intervaloDia ?? null
  defaultValues.tipoIntervalo = notificacaoFatura.tipoIntervalo ? notificacaoFatura.tipoIntervalo.toString() : null
  defaultValues.canalNotificacao = notificacaoFatura.canalNotificacao ? notificacaoFatura.canalNotificacao.toString() : 'EMAIL'
  defaultValues.repete = notificacaoFatura.repete ?? false

  const tags = [
    { tag: '#nomeCliente#', descricao: 'Nome do cliente' },
    { tag: '#valor#', descricao: 'Valor da fatura' },
    { tag: '#referencia#', descricao: 'Referência fatura' },
    { tag: '#vencimento#', descricao: 'Vencimento da fatura' }
  ];

  const {
      control,
      formState: { errors},
      handleSubmit
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.assunto && save(data);
  };

  const copiarTag = (tag: string) => {
    navigator.clipboard.writeText(tag);
    toast.current?.show({ severity: 'success', summary: 'Copiado', detail: `Tag ${tag} copiada!`, life: 2000 });
  };

  const save = (data:any) => {
    const notif = {
      id: notificacaoFatura.id? notificacaoFatura.id : undefined,
      assunto:data.assunto,
      mensagem:data.mensagem,
      intervaloDia:data.intervaloDia,
      tipoIntervalo:data.tipoIntervalo,
      canalNotificacao:data.canalNotificacao,
      repete:data.repete
    }
    window.scrollTo(0, 0);
    onSave(notif);
  }

  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  useEffect(() => {
    getTipoIntervaloNotificacao().then( (data) => setTiposIntervalo(data))
    getCanaisNotificacao().then( (data) => setCanais(data))
  }, [])

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <Toast ref={toast} />
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                  <Controller
                      name="assunto"
                      control={control}
                      rules={{ required: 'Assunto é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.assunto })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="assunto" className="font-bold block mb-2 required">{t('assunto')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
          </div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                  <Controller
                      name="intervaloDia"
                      control={control}
                      rules={{ required: 'Intervalo em dias é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.intervaloDia })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="intervaloDia" className="font-bold block mb-2 required">{t('intervaloDia')} </label>
                                <InputNumber id={field.name} value={field.value} onValueChange={(e) => field.onChange(e.value ?? null)} className={classNames({ 'p-invalid': fieldState.error })} min={0} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
              <div className="col">
                  <Controller
                      name="tipoIntervalo"
                      control={control}
                      rules={{ required: 'Tipo de Intervalo é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.tipoIntervalo })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="tipoIntervalo" className="font-bold block mb-2 required">{t('tipoIntervalo')} </label>
                                <Dropdown style={{width: '50%'}} value={field.value} onChange={(e) => field.onChange(e.value)} options={tiposIntervalo} optionLabel="label" optionValue="value" placeholder="Selecione Tipo de Intervalo"
                                  filter className="w-full md:w-14rem" />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
              <div className="col">
                  <Controller
                      name="canalNotificacao"
                      control={control}
                      rules={{ required: 'Canal é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.canalNotificacao })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="canalNotificacao" className="font-bold block mb-2 required">{t('canal')} </label>
                                <Dropdown style={{width: '50%'}} value={field.value} onChange={(e) => field.onChange(e.value)} options={canais} optionLabel="label" optionValue="value" placeholder="Selecione o Canal"
                                  filter className="w-full md:w-14rem" />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
              <div className="col">
                  <Controller
                      name="repete"
                      control={control}
                      render={({ field }) => (
                          <>
                              <div>
                                <label htmlFor="repete" className="font-bold block mb-2">{t('repete')} </label>
                                <InputSwitch id={field.name} checked={field.value} onChange={(e) => field.onChange(e.value)} />
                              </div>
                          </>
                      )}
                  />
              </div>
          </div>
          <div className="grid">
            <div className="col">
                <Controller
                      name="mensagem"
                      control={control}
                      render={({ field }) => (
                          <>
                              <div>
                                  <label htmlFor="mensagem" className="font-bold block mb-2">{t('mensagem')} </label>
                                  <Editor id={field.name} value={field.value} onTextChange={(e) => field.onChange(e.htmlValue)} style={{ height: '320px' }} />
                              </div>
                          </>
                      )}
                  />
              </div>
          </div>
          <div className="grid">
            <div className="col p-fluid">
                <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '6px', padding: '0.75rem 1rem', marginTop: '0.5rem' }}>
                <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#495057', display: 'block', marginBottom: '0.4rem' }}>
                    <i className="pi pi-info-circle" style={{ marginRight: '0.4rem' }} />Tags disponíveis (clique para copiar):
                </span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {tags.map((t) => (
                    <span
                        key={t.tag}
                        onClick={() => copiarTag(`${t.tag}`)}
                        style={{ backgroundColor: '#e3f2fd', borderRadius: '4px', padding: '0.25rem 0.6rem', fontSize: '0.8rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.3rem', transition: 'background-color 0.2s' }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#bbdefb')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                    >
                        <i className="pi pi-copy" style={{ fontSize: '0.7rem' }} />
                        <b>{`${t.tag}`}</b> {t.descricao}
                    </span>
                    ))}
                </div>
                </div>
            </div>
            </div>
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div>
    </form>
  )
}
